import React from 'react';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import {connect} from 'react-redux';
import MyButton from '../components/MyButton';
import TextField from 'material-ui/TextField';
import {
	INCOMPLETE_DATA,
	INTERRUPT_NOT_ALLOWED,
	NO_INTERRUPT_WHILE_INTERRUPTED,
	INTERRUPT_NOT_ALLOWED_CHEATED,
} from '../utils/constants';
import InfoSnack from '../utils/InfoSnack';
import './WalletScreen.css';
import Header from '../components/Header';
import LineGraph from "./LineGraph";
import {
    CHEATED, CONFIRMED, CURRENT_CONFIRMED, CURRENT_PAUSE, CURRENT_PENDING, MISSED, PAUSE,
    PAUSE_CONFIRMED, TOMORROW_PAUSE
} from "../overview/DayStates";
import {formatMoney} from "../utils/MoneyHelper";

class WalletScreen extends React.PureComponent {
	constructor() {
		super();
	}

    componentDidMount() {
       if(!this.props.initialOrder){
           this.props.goBack();
	   }
    }

    convertCents(cents) {
        return (cents / 100);
    }

    currentWalletValueString = () => {
        let sum = (this.dailyPerWorkout(this.props.period) * this.props.successfulMonths * 19);
        for (let i = 0; i < this.props.days.length; i++) {
            const day = this.props.days[i];
            if(day.state === CURRENT_CONFIRMED || day.state === CONFIRMED){
                sum = sum + this.dailyPerWorkout(this.props.period);
            }
            if(day.state === CURRENT_PENDING || day.state === CURRENT_CONFIRMED){
                break;
            }
        }

        if(sum === 0){
        	return formatMoney(sum, this.props.initialOrder.currency, 2);
		}else{
            return '+' + formatMoney(sum, this.props.initialOrder.currency, 2);
		}

	};

	data = () =>{
        const dataArray = [];
        let sum = (this.dailyPerWorkout(this.props.period) * this.props.successfulMonths * 19);

        //current month
        for (let i = 0; i < this.props.days.length; i++) {
        	const day = this.props.days[i];
            if(day.state === CURRENT_CONFIRMED || day.state === CONFIRMED){
                sum = sum + this.dailyPerWorkout(this.props.period);
            }
            if(i === 0)
                dataArray.push(Math.round((this.dailyPerWorkout(this.props.period) * this.props.successfulMonths * 19) * 100) / 100);
            dataArray.push(Math.round(sum * 100) / 100);
            if(day.state === CURRENT_PENDING || day.state === CURRENT_CONFIRMED){
                break;
            }
        }

        return dataArray;

	};


    labels = () =>{
        const labelsArray = [];
        for(let i=0; i < this.props.days.length; i++){
            const day = this.props.days[i];
            const dayOffset = this.props.successfulMonths * this.props.initialOrder.days_per_workout;
            if(i === 0)
                labelsArray.push("");
            labelsArray.push(this.props.t('overview:day') + " " + (i + dayOffset + 1));
            if(day.state === CURRENT_PENDING || day.state === CURRENT_CONFIRMED || day.state === CURRENT_PAUSE){
                break;
            }
        }
        return labelsArray;
    };

	dailyPerWorkout = (period) =>{
        const total = this.props.initialOrder.total;
        const extraPayout1 = this.props.initialOrder.extra_payout_1;
        const extraPayout2 = this.props.initialOrder.extra_payout_2;
        const extraPayout3 = this.props.initialOrder.extra_payout_3;
        const extraPayout4 = this.props.initialOrder.extra_payout_4;
        const totalCoupon = this.props.initialOrder.total_coupon ? this.props.initialOrder.total_coupon : 0;

        if (period === 1) {
            return this.convertCents((total + extraPayout1) / (19 * this.props.initialOrder.workouts_per_order));
        } else if (period === 2) {
            return this.convertCents((total + totalCoupon + extraPayout2)/ (19 * this.props.initialOrder.workouts_per_order));
        } else if (period === 3) {
            return this.convertCents((total + totalCoupon + extraPayout3)/ (19 * this.props.initialOrder.workouts_per_order));
        } else if (period === 4) {
            return this.convertCents((total + totalCoupon + extraPayout4)/ (19 * this.props.initialOrder.workouts_per_order));
        } else {
            return 0;
        }
	};

    getPayoutAmount() {
        const total = this.props.initialOrder.total;
        const period = this.props.period;
        const extraPayout1 = this.props.initialOrder.extra_payout_1;
        const extraPayout2 = this.props.initialOrder.extra_payout_2;
        const extraPayout3 = this.props.initialOrder.extra_payout_3;
        const extraPayout4 = this.props.initialOrder.extra_payout_4;
        const totalCoupon = this.props.initialOrder.total_coupon ? this.props.initialOrder.total_coupon : 0;

        if (period === 1) {
            return this.convertCents(total * period + extraPayout1);
        } else if (period === 2) {
            return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout2);
        } else if (period === 3) {
            return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout3);
        } else if (period === 4) {
            return this.convertCents((total + totalCoupon) * period - totalCoupon + extraPayout4);
        } else {
            return this.convertCents((total + totalCoupon) * 4 - totalCoupon + extraPayout4);
        }
    }

	render() {
		const {t} = this.props;
		return (
			<div className='pauseScreenWrapper'>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<Header
					onBackPress={() => this.props.goBack()}
					title={t('wallet:title')}
				/>
				<div style={styles.shareContainer}>
					{this.props.initialOrder && (
					<div>
					<p style={styles.walletValue}>{this.currentWalletValueString()}</p>
					<LineGraph
						data={this.data()}
						dataTitle={t('wallet:chartLabel')}
						labels={this.labels()}
						currency={this.props.initialOrder.currency}/>

						<p style={styles.walletDescription}>{t('wallet:description', {
                            payoutAmount: formatMoney(this.getPayoutAmount(), this.props.initialOrder.currency, 0)
                        })}
						</p>
					</div>)}
				</div>
			</div>
		);
	}
}

const styles = {
	textInput: {
		paddingTop: 10,
	},
	shareContainer: {
		maxWidth: 512,
		margin: '0 auto',
		paddingTop: 72,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
    walletValue: {
        fontSize: 40,
        marginBottom: 24,
        textAlign: 'center',
        fontWeight: 'bold',
		color: colors.white
    },
    walletDescription: {
		color: colors.white,
        textAlign: 'center',
		marginTop: 35
	}
};

const mapStateToProps = (state) => {
	return {
		pauseLoading: state.pauseLoading,
		pauseSuccess: state.pauseSuccess,
		loadingPauseFailed: state.loadingPauseFailed,
		betMode: state.betMode,
        initialOrder: state.initialOrder,
        periodBegin: state.periodBegin,
        period: state.period,
        openDays: state.openDays,
        successfulMonths: state.successfulMonths,
        days: state.days,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['wallet', 'overview', 'common'])(WalletScreen));



// WEBPACK FOOTER //
// ./src/wallet/WalletScreen.js